import get from 'transmute/get';
export const getCallableObjectAndAssociations = get('callableObjectAndAssociations');